import cn from 'classnames';

const bem = (...blockNames) => {
    const modsToClass = (className, mods) => {
        return mods.filter(mod => mod !== '').map(mod => {
            if (Array.isArray(mod)) {
                return mod.map( m => `${className}--${m}`);
            } else if (typeof(mod) === 'string') {
                return `${className}--${mod}`;
            } else if (typeof(mod) === 'object') {
                const result = {};
                for (let key in mod) {
                    result[`${className}--${key}`] = mod[key];
                }
                return result;
            } else {
                console.error(`unknown mod type `, mod);
            }
        });
    };

    const block = (...mod) => {
        const modClassNames = blockNames.map(className => modsToClass(className, mod));
        return cn(blockNames, modClassNames);
    };

    const el = (elName, ...mods) => {
        const classNames = blockNames.map(blockName => `${blockName}__${elName}`);
        const modsClassNames = classNames.map(className => modsToClass(className, mods));
        return cn(classNames, modsClassNames);
    };

    const cnBlock = (className, ...mods) => {
        const classNames = Array.isArray(className) ? [...blockNames, ...className] : [...blockNames, className];
        const modsClassNames = classNames.filter(x => !!x).map(className => modsToClass(className, mods));
        return cn(blockNames, className, modsClassNames)
    };

    const cnEl = (className, elName, ...mods) => {
        const classNames = [
            ...blockNames.map(blockName => `${blockName}__${elName}`),
            className
        ];
        const modsClassNames = classNames.map(className => modsToClass(className, mods));
        return cn(classNames, modsClassNames);
    };

    return {block, el, cnBlock, cnEl}
}

export default bem;
